import { store } from "../store/store.js";
import { UNIT, VALUE } from "../constant/constant.js";


export function transformData(data) {
    function buildTree(node) {
        const key = node.id;
        const label = node.name;
        const children = node.children.map(child => buildTree(child, key));
        return { key, label, children };
      }
    return data.map(category => buildTree(category));
}

export const getFileSize = (size) => {
  if (size < 1024) return `${size} B`;
  else if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
  else if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  else return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};

export const getFileCategoryType = (file) => {
  const mime = file.type?.toLowerCase() || "";
  const name = file.name?.toLowerCase() || "";

  if (mime.startsWith("image/")) return "image";
  if (mime === "application/pdf") return "pdf";
  if (mime.startsWith("audio/")) return "audio";
  if (mime.startsWith("video/")) return "video";
  if (
    mime === "application/zip" ||
    mime === "application/x-zip-compressed" ||
    name.endsWith(".zip")
  ) return "zip";
  if (
    mime === "application/msword" ||
    mime === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
    name.endsWith(".doc") || name.endsWith(".docx")
  ) return "word";
  if (
    mime === "application/vnd.ms-excel" ||
    mime === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    name.endsWith(".xls") || name.endsWith(".xlsx")
  ) return "excel";
  if (
    name.endsWith(".rar") || name.endsWith(".7z") || name.endsWith(".tar") || name.endsWith(".gz")
  ) return "compressed";

  return "unknown";
};

export const downloadFileFromUrl = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.setAttribute("download", true);
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

export const handleToggleSingleIds = (uuid, arr = []) => {
  if (arr.includes(uuid)) {
    return arr.filter((id) => id !== uuid);
  } else {
    return [...arr, uuid];
  }
};

export const checkUserAllowPermissions = (data) =>{
  let allConfig =  store.getState();
  const { user } = allConfig.userSlice;
  let permissions = user.permissions
  const dataArray = Array.isArray(data) ? data : [data];
  return dataArray.every((item) => permissions.includes(item));
}

export const toBytes = (sizeObj) => {
  const units = {
    GB: 1024 ** 3,
    MB: 1024 ** 2,
    KB: 1024,
    B: 1,
  };
  return sizeObj[VALUE] * units[sizeObj[UNIT]];
};

/**
 * Check file size with units: GB, MB, KB, BYTES
 * @param {File} file - uploaded file
 * @param {number} maxSize - max allowed size
 * @param {"GB"|"MB"|"KB"|"B"} unit - unit of maxSize
 * @returns {boolean} true if file is too large
 */

export const isFileSizeOverMaxSize = (fileSize, maxSizeObj) => {
  return fileSize > toBytes(maxSizeObj);
}

export const getAllowedMaxFileSize = (data) =>{
  return data[VALUE]+data[UNIT]
}
